<template>
    <div class="page-wapper">
        <mui-loading
            v-if="showLoading"
            :visable="showLoading"
            theme="blue"
        />
        <mui-errorloading v-else-if="isError"/>
        <div v-else class="main">
            <!-- 顶部 logo 部分 -->
            <div class="top" :class="isWeek ? 'jd-week' : 'jd-normal'">
                <div class="logo"></div>
                <div v-if="isWeek" class="week-tip"></div>
                <div class="coupon" :class="isWeek ? 'coupon-25' : 'coupon-100'"></div>
            </div>
            <!-- 输入框主体 -->
            <div v-if="status === 1" class="input-content">
                <div v-if="phoneTip" class="error-tip">请输入正确的手机号</div>
                <input
                    v-model="phone"
                    type="tel"
                    class="cell-number"
                    placeholder="输入手机号,领打车红包"
                    onfocus="this.placeholder = ''"
                    @blur="lostFocus($event)"
                >
                <button
                    class="get"
                    :class="{'disable': !isActive}"
                    @click="getRedPacket"
                >立即领取</button>
                <div class="btn-tip" @click="jumpUrl">输入手机号并点击领取，即视为同意<span class="link">《百度相关服务协议》</span></div>

            </div>
            <!-- 红包部分-->
            <div v-if="status === 2" class="red-packet">
                <div :class="couponInfo.length > 3 ? 'four' : ''">
                    <div
                        v-for="item in couponInfo"
                        :key="item.type"
                        class="red"
                    >
                        <div class="content">
                            <p class="price">{{ item.price }}</p>
                            <p class="desc">
                                <span class="new-or-old">有效期至{{ item.expire }}</span>
                                <br>
                                <span class="expire no-newuser-logo">限手机号{{ item.mobile }}使用</span>
                            </p>
                            <div class="coupon-name">
                                <div class="coupon-type">{{ item.type }}</div>
                                <div class="coupon-dec">{{ item.desc }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="{gradient: couponInfo.length > 3}"></div>
            </div>
            <!-- 容错部分 -->
            <div v-if="status === 3" class="error-content">
                <div class="error">
                    <!--bca-disable-next-line-->
                    <div v-html="tip">
                    </div>
                </div>
            </div>
            <!-- 一键比价，更快出发 -->
            <div class="comparePrice">
                <div class="title">{{ section.comparePrice }}</div>
                <div class="panel"></div>
            </div>
            <!-- 活动规则 -->
            <div class="rule">
                <div class="title">{{ section.rule }}</div>
                <div class="panel">
                    <div class="custom">
                        <p>1.用户输入手机号后点击“一键领取”，即可领取成功，打车礼包发放至输入手机号对应的百度地图账户，用该手机号在百度地图APP打车时使用；</p>
                        <p>2.活动期间，每位京东PLUS会员{{ ruleText.dec }}百度地图打车福利礼包，
                            内含{{ ruleText.more }}快车、专车优惠券，有效期以领取后优惠券面显示为准；</p>
                        <p>3.打车优惠券可在百度地图APP首页点击“路线-打车”-右上角选择“优惠券”进行查看；</p>
                        <p>4.打车券仅限在百度地图打车线上支付使用，不可与其他优惠券叠加使用，每用户每单限用一张；</p>
                        <p>5.如有疑问请联系百度地图客服：400-099-8998。</p>
                    </div>
                </div>
            </div>
            <!-- plus会员福利展示 -->
            <div class="plus">
                <div class="plus-title"></div>
                <div class="plus-content"></div>
            </div>
        </div>
        <!-- 弹窗 -->
        <dialog-box
            v-if="isShowDialog"
            :dialog-type="dialogType"
            :amount="amount"
            :pop-text="popText"
            @onClose="closeDialogBox"
        />
    </div>

</template>

<script>

import './Main.scss';
import {jumpDacheMain, jumpCoupon, jumpDachePage} from '../../constant/JumpFunc.js';
import server from '../../service.js';
import {preload} from '../../constant/proload.js';
// import DialogBox from './components/dialog/DialogBox';
import com from '@/common/utils/com.js';
import {timestamp2Time} from '../../constant/timestamp2Time.js';
import {homeShare} from '../../constant/ShareConfig.js';
import StatisticConst from '../../constant/StatisticConst.js';
import md5 from 'js-md5';

// 引入静态资源
// import mainBg from '../../assets/main-bg.jpg';
// import mainBtn from '../../assets/main-btn.png';
// import car from '../../assets/car.png';

export default {
    data() {
        return {
            isError: false,
            imgReady: false, // 图片预加载完毕标志位
            fetching: false, // 分享获取完毕标志位
            isShowDialog: false, // 弹窗
            dialogType: 0, // 弹窗类型
            status: 1, // 进入活动状态
            isActive: false, // 按钮可点击状态
            tip: '',
            phone: '',
            couponInfo: [],
            group: [],
            // 页面首次加载时获取信息的错误码
            detailErrNo: 0,
            phoneTip: false,
            localphone: '',
            errnoTip: false,
            reqParams: {
                'group_idx': '',
                'activity_type': ''
            },
            showOthers: true,
            isWeek: true,
            buttonText: '立即使用',
            topics: [
                {
                    subTitle: '百度网盘',
                    desc: '超级会员月卡',
                    btn: '免费领取',
                    href: 'https://plus.m.jd.com/liferight/detail?uniqueId=12275516710276',
                    btnImg: '../images/plus-free-btn.png'
                },
                {
                    subTitle: '团油',
                    desc: '全国加油8折月卡',
                    btn: '免费领取',
                    href: 'https://plus.m.jd.com/liferight/detail?uniqueId=12274816261723',
                    btnImg: '../images/plus-free-btn.png'
                },
                {
                    subTitle: '泊安飞',
                    desc: '机场停车金牌会籍',
                    btn: '免费领取',
                    href: 'https://plus.m.jd.com/liferight/detail?uniqueId=1881415889365',
                    btnImg: '../images/plus-free-btn.png'
                }
            ],
            section: {
                comparePrice: '一键比价 更快出发',
                rule: '活动规则'
            }
        };
    },
    // components: {
    //     DialogBox
    // },
    computed: {

        /**
         * 端内隐藏分享
         */
        // showShare() {
        //     return com.plat.isNative;
        // }
        /**
         * 显示loading
         */
        showLoading() {
            // console.log(this.imgReady, this.fetching);
            return this.imgReady || this.fetching;
        },
        ruleText() {
            return {
                dec: this.isWeek ? '每周可领取一次' : '可领取100元',
                more: this.isWeek ? '' : '多张'
            };
        }
    },
    created() {
        // 先拉取活动状态
        this.getDeatil();



    },
    mounted() {
        // 判断是否周常活动
        const urlParams = com.getParamsFromUrl();
        this.isWeek = +urlParams.week === 1;

        // 取出缓存中的手机号并对比时间是否过期
        if (localStorage.length !== 0) {
            let nowDate = new Date();
            let localDate = new Date(localStorage.getItem('time'));
            // 计算缓存时间和当前时间差
            let dateDiff = nowDate.getTime() - localDate.getTime();
            let hour = dateDiff / (3600 * 1000);
            if (hour < 24) {
                // 缓存不过期读取缓存手机号进入领取逻辑
                this.phone = Number(localStorage.getItem('userPhone'));
            }
            else {
                localStorage.clear();
            }
        }
    },
    watch: {},
    methods: {
        /**
         * 预加载首页图片资源
         */
        // preloadImg() {
        //     preload([mainBg, mainBtn, car]).then(() => {
        //         this.imgReady = true;
        //     });
        // },

        /**
         * 刚进首页获取活动状态、拼接领取红包参数
         */
        getDeatil() {
            // this.fetching = true;

            const that = this;
            const param = {
                src_from: '3',
                // cuid: '',
                activity: 'yongchemobilecoupon',
                fr: 'normal'
                // group: '',
                // activity_type: '',
                // group_idx: ''

            };
            server('getDetail', param)
                .then(res => {
                    that.isActive = true;
                    if (res.errno === 0) {
                        this.isActive = true;
                        this.reqParams = {
                            group_idx: res.data.group_idx,
                            activity_type: res.data.activity_type
                        };
                    }
                    else {
                        this.$toast('获取数据失败');
                    }
                }
                )
                .catch(e => {
                    this.$toast('获取数据失败');
                });


        },

        /**
         * 根据手机号调用接口领取红包
         */
        getRedPacket() {
            const that = this;
            if (!this.isActive) {
                return;
            }

            // 校验手机号
            if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))) {
                this.phoneTip = true;
                this.phone = '';
                return;
            }

            // 第一次提交 缓存时间和手机号
            if (localStorage.getItem('userPhone') === null) {
                let localDate = new Date();
                localStorage.setItem('userPhone', this.phone);
                localStorage.setItem('time', localDate);
            }
            const param = {
                src_from: 3,
                activity: 'yongchemobilecoupon',
                mobile: this.phone,
                group_idx: this.reqParams.group_idx || '',
                activity_type: this.reqParams.activity_type || ''
            };
            server('getRedPackt', param)
                .then(res => {
                    if (res) {
                        // 主体部分展示红包
                        that.status = 2;
                        this.dataSuccess(res.errno, res.data);
                    }
                    else {
                        // 展示错误部分
                        that.status = 3;
                        this.onDataFailed(res.errno);
                    }
                }
                )
                .catch(e => {
                    this.$toast('领取失败,请稍后重试');
                });
        },

        /**
         * 转换时间戳
         * @param {Number} showTime 原始时间戳
         * @param {String} fmt 时间格式 默认xx月xx日
         * @return fmt 转换后的时间字符串
         */
        timeTrans(showTime, fmt) {
            let date = new Date(showTime);
            let obj = {
                'M+': date.getMonth() + 1, // 月份
                'd+': date.getDate(), // 日
                'h+': date.getHours(), // 小时
                'm+': date.getMinutes() // 分
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (this.getFullYear() + ''));
            }
            for (let k in obj) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1)
                        ? (obj[k]) : (('00' + obj[k]).substr(('' + obj[k]).length)));
                }
            }
            return fmt;
        },

        /**
         * 处理数据回调 红包数据符合前端展示逻辑
         * @param {Number} errno 服务返回数据码 用于判断活动是否正常进行
         * @param {Object}  服务返回原始数据
         */
        dataSuccess(errno, data) {
            // 用户已经登录过使用toast并发送统计

            if (data.has_grant === 1) {
                this.$toast('您已经领取过红包啦');
            }

            // // 数据加载成功后再设置背景色，否则loading的时候在iphonex等设备上
            // // 底部安全区域会露出背景色，而loading的背景色又是白的
            // const color = '#141f3e';
            // document.body.style.background = color;
            // document.querySelector('#app').style.background = color;
            // 处理卡券数组
            if (errno === 0) {

                data.coupon_info.map(
                    item => {

                        let coupon = {};
                        if (item.type === 0) {
                            coupon.type = '通用券';
                        }
                        else if (item.type === 1) {
                            coupon.type = '专车券';
                        }
                        else if (item.type === 2) {
                            coupon.type = '快车券';
                        }
                        else if (item.type === 3) {
                            coupon.type = '出租车券';
                        }
                        coupon.price = item.discount_price / 100;
                        coupon.desc = item.discount_desc;
                        coupon.mobile = item.mobile.slice(0, 3) + '*****' + item.mobile.slice(8, 11);
                        coupon.expire = this.timeTrans(item.expire * 1000, 'MM月dd日hh点');
                        this.couponInfo.push(coupon);

                    }
                );
            }
            else {
                this.tip = '红包已经抢完啦';
            }

        },

        /**
         * 处理数据失败回调 展示兜底逻辑
         * @param {Number} errno 服务返回数据码 用于判断活动状态
         */
        onDataFailed(errno) {
            // 底部安全区域会露出背景色，而loading的背景色又是白的
            const color = '#141f3e';
            document.body.style.background = color;
            // document.querySelector('#app').style.background
            // = 'linear-gradient(180deg, #00ce7e 80%, #00aa65 100%);'
            document.querySelector('#app').style.background = '#e3e3e3';
            // 处理各种错误码
            switch (+errno) {
                case 2003:
                    this.tip = '网络失败 <br>请重试';
                    break;
                case 4001:
                    this.tip = '您的请求过于频繁 <br>请稍后再试';
                    break;
                case 5005:
                    this.tip = '兑换失败 <br>请重试';
                    break;
                case 5002:
                    this.tip = '今日领取次数已达上限';
                    break;
                case 2002:
                    this.tip = '活动已经结束';
                    break;
            }
        },

        /**
         * 跳转百度打车协议
         */
        jumpUrl() {
            const url = 'https://yongche.baidu.com/#/protocol';
            window.location = url;
            // jumpDachePage(url);
        },

        /**
         * 输入框失去焦点回到顶部
         */
        lostFocus(e) {
            e.target.placeholder = '输入手机号，领打车红包';
            scrollTo(0, 0);
        },


        /**
         * 展示未登录弹窗
         */
        showLogin() {
            // 登录点击
            StatisticConst.jumpLogin();
            this.isShowDialog = true;
            this.dialogType = 6;
        },

        share() {
            // 添加分享统计
            StatisticConst.shareBtnClick();
            window.yymap.naa.openShare();
        },

        /**
         * 跳转至打车页面
         */
        jumpDache() {
            // 打车按钮统计
            StatisticConst.dacheBtnClick();
            jumpDacheMain();
        },

        /**
         * 跳转至打车金页面
         */
        jumpIntegral() {
            // '查看奖品'按钮统计
            StatisticConst.prizeBtnClick();
            jumpCoupon(1);
        },

        /**
         * 跳转至优惠券主页
         */
        // jumpCouponMain() {
        //     // '查看奖品'按钮统计
        //     StatisticConst.prizeBtnClick();
        //     jumpCoupon(0);
        // },


        /**
         * 关闭弹窗
         */
        closeDialogBox() {
            this.isShowDialog = false;
            this.dialogType = null;
        },

        /**
         * 打开规则弹窗
         */
        showRule() {
            // 规则统计
            StatisticConst.ruleBtnClick();
            this.isShowDialog = true;
            this.dialogType = 8;
        }
    }
};
</script>

<style lang="scss" scoped></style>
